import gql from 'graphql-tag';

const unitMessageFragments = {
    UnitMessage: gql`
        fragment UnitMessageUnitMessage on UnitMessage {
            iconText {
                message
                icon
                messageValueType
            }
        }
    `,
};

export default unitMessageFragments;
